import { useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  CustomDateTabs,
  CustomDialog,
  CustomTable,
  Filter,
  FilterTag,
} from "../../../../components";

import { envChangeType, getCurrency } from "../../../../plugins/utils";
import { filterKeyBetRecordData } from "../../enumeration/filterKeyEnum";
import { filterSetupBetRecordData } from "../../enumeration/filterSetupEnum";
import {
  useGetBetInquiryGames,
  useGetBetInquirySubGames,
  useGetBetRecord,
} from "../../hooks/betinquiry.hook";
import {
  columns77Lottery,
  columnsAESexy,
  columnsAg,
  columnsBlockchain,
  columnsCQ9,
  columnsCRSport,
  columnsEVO,
  columnsEvoPlay,
  columnsFBSport,
  columnsFC,
  columnsFCFish,
  columnsFFFLive,
  columnsJDBFish,
  columnsJDBSlot,
  columnsJILI,
  columnsJILIFish,
  columnsJollySport,
  columnsLuckySport,
  columnsMg,
  columnsMinigame,
  columnsONEEVOLIVE,
  columnsONEGlobal,
  columnsONEHACKSAW,
  columnsONEJDBSlot,
  columnsONEJDFish,
  columnsONEJILICARD,
  columnsONEJILICASINO,
  columnsONEJILIFISH,
  columnsONEJILISLOT,
  columnsONEPG,
  columnsONEPP,
  columnsONEPPLIVE,
  columnsONESABA,
  columnsOmg,
  columnsPG,
  columnsPP,
  columnsPPLive,
  columnsPT,
  columnsPlayStar,
  columnsSBOSport,
  columnsSaba,
  columnsSpribe,
  columnsSpribeOne,
  columnsT1,
  columnsTCG,
  columnsViaCasinoLive,
  columnsWCF,
  columnsWEblockchain,
  columnsWEfish,
  columnsWElive,
  columnsWElottery,
  columnsWEslot,
  columnsWEsport,
  columnsWinLottery,
  columnsYBSlot,
  columnsYGG,
  columnsYoubet,
} from "./components/Columns";
import "./style.scss";

const VN_NUMBERS_GROUP = [
  {
    position: "seventh",
    lot_count: 4,
  },
  {
    position: "sixth",
    lot_count: 3,
  },
  {
    position: "fifth",
    lot_count: 6,
  },
  {
    position: "fourth",
    lot_count: 4,
  },
  {
    position: "third",
    lot_count: 6,
  },
  {
    position: "second",
    lot_count: 2,
  },
  {
    position: "first",
    lot_count: 1,
  },
  {
    position: "special",
    lot_count: 1,
  },
];

function Report() {
  // const [totalSum, setTotalSum] = useState(0);
  const { t } = useTranslation();
  const cache = useQueryClient();
  const nowCurrency = getCurrency();
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);

  const [filterDefaultValue, setFilterDefaultValue] = useState({
    [filterKeyBetRecordData.ACCOUNT]: "",
    [filterKeyBetRecordData.GAME_CODE]: null,
    [filterKeyBetRecordData.GAME_SUB_CODE]: "",
    [filterKeyBetRecordData.START_DATE]: dayjs().format("YYYY-MM-DD 00:00:00"),
    [filterKeyBetRecordData.END_DATE]: dayjs().format("YYYY-MM-DD 23:59:59"),
    [filterKeyBetRecordData.UPPER_ACCOUNT]: "",
  });
  const [filterValue, setFilterValue] = useState({
    [filterKeyBetRecordData.ACCOUNT]: "",
    [filterKeyBetRecordData.GAME_CODE]: null,
    [filterKeyBetRecordData.GAME_SUB_CODE]: "",
    [filterKeyBetRecordData.START_DATE]: dayjs().format("YYYY-MM-DD 00:00:00"),
    [filterKeyBetRecordData.END_DATE]: dayjs().format("YYYY-MM-DD 23:59:59"),
    [filterKeyBetRecordData.UPPER_ACCOUNT]: "",
  });

  const [dependency, setDependency] = useState({});

  const [gameValues, setGameValues] = useState([]);
  // const [gameSubGamesValues, setSubGamesValues] = useState([]);
  const { data: gameList } = useGetBetInquiryGames({});
  // const { data: subGameList } = useGetBetInquirySubGames(
  //   {
  //     enabled: filterValue[filterKeyBetRecordData.GAME_CODE] !== null,
  //   },
  //   filterValue[filterKeyBetRecordData.GAME_CODE],
  // );
  // const allSubGames = useGetAllBetInquirySubGames(
  //   {
  //     enabled: filterValue[filterKeyBetRecordData.GAME_CODE] !== null,
  //     refetch: false,
  //   },
  //   gameList,
  // );

  const vn_result_columns = [
    {
      title: "",
      width: 60,
      align: "center",

      dataIndex: "position",
      render: (_, data) => {
        return t(`LOTVN.result.${data.position}.prize`);
      },
    },
    {
      title: "",
      align: "center",
      dataIndex: "numbers",
    },
  ];

  const allSubGames = useGetBetInquirySubGames(
    {
      enabled: false,
      refetch: false,
    },
    dependency[filterKeyBetRecordData.GAME_CODE],
  );

  const getBetRecord = useGetBetRecord({
    options: {
      getNextPageParam: (lastPage, pages) => {
        if (pages.length < lastPage.last_page) {
          return pages.length + 1;
        } else {
          return undefined;
        }
      },
      enabled: filterValue[filterKeyBetRecordData.GAME_CODE] !== null,
    },
    params: {
      account: filterValue[filterKeyBetRecordData.ACCOUNT],
      start_date: filterValue[filterKeyBetRecordData.START_DATE],
      end_date: filterValue[filterKeyBetRecordData.END_DATE],
      page_size: 20,
      game_code: filterValue[filterKeyBetRecordData.GAME_CODE],
      game_sub_code: filterValue[filterKeyBetRecordData.GAME_SUB_CODE],
      upper_agent_account: filterValue[filterKeyBetRecordData.UPPER_ACCOUNT],
    },
  });

  const renderAllResult = (data) => {
    if (data === undefined) {
      return <p>{t("presetSetting.viewResult.confirm")}</p>;
    } else {
      let acc = 0;
      const allPositions = VN_NUMBERS_GROUP.map((group) => {
        const numbers = data.slice(acc, group.lot_count + acc).join("-");
        acc += group.lot_count;
        return {
          ...group,
          numbers: numbers,
        };
      });
      return (
        <CustomTable
          customClass="vn-result-table"
          columns={vn_result_columns}
          pagination={false}
          search={false}
          dataSource={allPositions.reverse()}
          showInifineScroll={false}
        />
      );
    }
  };

  const onLotteryNumberClick = (data) => {
    console.debug(data);

    CustomDialog({
      type: "show",
      customClass: "vn-result-dialog",
      dialogProps: {
        header: data.period,
        destroyOnClose: true,
        closeOnAction: true,
        content: renderAllResult(data?.lottery_number?.period_result_number),
        actions: [
          {
            key: "close",
            text: t("normal.close"),
          },
        ],
      },
    });
  };

  const getColumn = (gameCode) => {
    const dict = {
      saba: columnsSaba(t),
      jollysport: columnsJollySport(t),
      winlottery: columnsWinLottery(t),
      blockchain: columnsBlockchain(t),
      "77lottery": columns77Lottery(t, onLotteryNumberClick),
      mg: columnsMg(t, allSubGames.data),
      t1: columnsT1(t),
      evo: columnsEVO(t),
      pp: columnsPP(t, allSubGames.data),
      pg: columnsPG(t, allSubGames.data),
      ygg: columnsYGG(t),
      evoplay: columnsEvoPlay(t),
      jili: columnsJILI(t),
      jdb: columnsSpribe(t),
      pt: columnsPT(t),
      pplive: columnsPPLive(t),
      cq9: columnsCQ9(t),
      fc: columnsFC(t),
      playstar: columnsPlayStar(t),
      welottery: columnsWElottery(t),
      welive: columnsWElive(t),
      weblockchain: columnsWEblockchain(t),
      tcg: columnsTCG(t),
      jilifish: columnsJILIFish(t),
      youbet: columnsYoubet(t),
      aesexy: columnsAESexy(t),
      spribeone: columnsSpribeOne(t),
      wesport: columnsWEsport(t),
      luckysport: columnsLuckySport(t),
      ybslot: columnsYBSlot(t),
      wefish: columnsWEfish(t),
      weslot: columnsWEslot(t),
      fcfish: columnsFCFish(t),
      jdbfish: columnsJDBFish(t),
      jdbslot: columnsJDBSlot(t),
      onejdbslot: columnsONEJDBSlot(t),
      onejdbfish: columnsONEJDFish(t),
      onepp: columnsONEPP(t),
      onepg: columnsONEPG(t),
      onehacksaw: columnsONEHACKSAW(t),
      onejilislot: columnsONEJILISLOT(t),
      onejilifish: columnsONEJILIFISH(t),
      onejilicard: columnsONEJILICARD(t),
      onejilicasino: columnsONEJILICASINO(t),
      oneevolive: columnsONEEVOLIVE(t),
      onepplive: columnsONEPPLIVE(t),
      onesaba: columnsONESABA(t),
      onehabaneropoker: columnsONEGlobal(t),
      onekingmidaspoker: columnsONEGlobal(t),
      onekypoker: columnsONEGlobal(t),
      one365poker: columnsONEGlobal(t),
      onegtfslot: columnsONEGlobal(t),
      onemicroslot: columnsONEGlobal(t),
      onespadeslot: columnsONEGlobal(t),
      onerelaxslot: columnsONEGlobal(t),
      onehabaneroslot: columnsONEGlobal(t),
      onenetentslot: columnsONEGlobal(t),
      oneredtigerslot: columnsONEGlobal(t),
      onebigtimeslot: columnsONEGlobal(t),
      onenolimitcityslot: columnsONEGlobal(t),
      onebngslot: columnsONEGlobal(t),
      oneadvantplayslot: columnsONEGlobal(t),
      oneevoplayslot: columnsONEGlobal(t),
      onekingmidasslot: columnsONEGlobal(t),
      oneepicwinslot: columnsONEGlobal(t),
      onelive22slot: columnsONEGlobal(t),
      onecgslot: columnsONEGlobal(t),
      onedbslot: columnsONEGlobal(t),
      onethunderkickslot: columnsONEGlobal(t),
      onepaslot: columnsONEGlobal(t),
      oneplaytechslot: columnsONEGlobal(t),
      onealizeslot: columnsONEGlobal(t),
      oneavataruxslot: columnsONEGlobal(t),
      onethebetterslot: columnsONEGlobal(t),
      oneendorphinaslot: columnsONEGlobal(t),
      onelucky365slot: columnsONEGlobal(t),
      onewinfinitylive: columnsONEGlobal(t),
      oneyeebetlive: columnsONEGlobal(t),
      oneezugilive: columnsONEGlobal(t),
      onemicrolive: columnsONEGlobal(t),
      onepalive: columnsONEGlobal(t),
      oneaasexylive: columnsONEGlobal(t),
      onewmlive: columnsONEGlobal(t),
      oneplaytechlive: columnsONEGlobal(t),
      onedblive: columnsONEGlobal(t),
      onecq9live: columnsONEGlobal(t),
      onebiglive: columnsONEGlobal(t),
      onealizemini: columnsONEGlobal(t),
      oneaviatrixmini: columnsONEGlobal(t),
      onelitemini: columnsONEGlobal(t),
      oneaviatormini: columnsONEGlobal(t),
      onemicroarcade: columnsONEGlobal(t),
      agjilislot: columnsAg(t),
      agpgslot: columnsAg(t),
      agppslot: columnsAg(t),
      agjdbslot: columnsAg(t),
      agbgslot: columnsAg(t),
      agfcslot: columnsAg(t),
      agcpslot: columnsAg(t),
      agwgslot: columnsAg(t),
      agtadaslot: columnsAg(t),
      aghsdslot: columnsAg(t),
      omgspribe: columnsOmg(t),
      omgpgslot: columnsOmg(t),
      omgppslot: columnsOmg(t),
      omghacksaw: columnsOmg(t),
      omgjilislot: columnsOmg(t),
      omgminigame: columnsOmg(t),
      omgtadaslot: columnsOmg(t),
      omgcpslot: columnsOmg(t),
      omgaskmeslot: columnsOmg(t),
      omglottery: columnsOmg(t),
      omgcasino: columnsOmg(t),
      omgjdbslot: columnsOmg(t),
      omgwgslot: columnsOmg(t),
      omg759slot: columnsOmg(t),
      omgredtiger: columnsOmg(t),
      omgfcslot: columnsOmg(t),
      omgigtslot: columnsOmg(t),
      omg2jgame: columnsOmg(t),
      omgslotmill: columnsOmg(t),
      omggameartslot: columnsOmg(t),
      viacasinolive: columnsViaCasinoLive(t),
      ffflive: columnsFFFLive(t),
      wcf: columnsWCF(t),
      minigame: columnsMinigame(t),
      sbosport: columnsSBOSport(t),
      crsport: columnsCRSport(t),
      fbsport: columnsFBSport(t),
    };
    return dict[gameCode] ?? [];
  };

  useEffect(() => {
    if (getBetRecord.data) {
      const page_length = getBetRecord.data.pages.length;
      if (page_length <= 1) {
        setTableData([...getBetRecord.data.pages[0].data]);
        // setTotalSum(getBetRecord?.data?.pages[0]?.total_sum_win_loss);
      } else {
        setTableData((prevState) => {
          return [...prevState, ...getBetRecord.data.pages[page_length - 1].data];
        });
      }
    }
  }, [getBetRecord.data]);

  useEffect(() => {
    if (!!gameList) {
      const _gameValues = gameList.map((game) => {
        return {
          value: game.game_3th_code,
          // category_id: game.game_category_id,
          label: [
            `normal.game.${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}.${game.game_3th_code}`,
            `normal.game.${game.game_3th_code}`,
          ],
          is_translation: true,
        };
      });
      setGameValues(_gameValues);
      setFilterDefaultValue((prevState) => {
        return {
          ...prevState,
          [filterKeyBetRecordData.GAME_CODE]: _gameValues[0].value,
        };
      });
      setFilterValue((prevState) => {
        return {
          ...prevState,
          [filterKeyBetRecordData.GAME_CODE]: _gameValues[0].value,
          [filterKeyBetRecordData.GAME_SUB_CODE]: "",
        };
      });
      setDependency((prevState) => {
        return {
          ...prevState,
          [filterKeyBetRecordData.GAME_CODE]: _gameValues[0].value,
        };
      });
    }
  }, [gameList]);

  useEffect(() => {
    console.log("dependency", dependency);
    if (Object.keys(dependency).length > 0) {
      setFilterValue({
        ...filterValue,
        ...dependency,
        [filterKeyBetRecordData.GAME_SUB_CODE]: "",
      });
    }
  }, [dependency, gameValues]);

  useEffect(() => {
    if (!!filterValue[filterKeyBetRecordData.GAME_CODE]) {
      const gameColumns = getColumn(filterValue[filterKeyBetRecordData.GAME_CODE]);
      setColumns(gameColumns);
    }
  }, [filterValue]);

  const onHandleSearch = () => {
    // cache.invalidateQueries([queryKey.PRODUCT_REPORT]);
    // console.log("filterValue", filterValue);
  };

  useEffect(() => {
    // if (!!allSubGames && allSubGames !== {}) {
    //   const allGames = [];
    //   Object.keys(allSubGames).map((brand) => {
    //     const setting = subGameListSetting[brand] ?? subGameListSetting.default;
    //     if (allSubGames[brand].length > 0) {
    //       allSubGames[brand]?.map((gameData) => {
    //         allGames.push({
    //           value: gameData[setting.gameCodeApiKey],
    //           label: setting.isGameNameTranslate
    //             ? `${setting.translatePrefixKeyname}${gameData[setting.translateParamKey]}`
    //             : gameData.name,
    //           is_translation: setting.isGameNameTranslate,
    //         });
    //       });
    //     }
    //   });
    //   console.log("allGames", allGames);
    // }

    // if (!!allSubGames?.find((game) => game.data === undefined)) {
    //   return;
    // } else {
    console.log("allSubGames", allSubGames.data);
    // }
  }, [allSubGames.data]);

  return (
    <div>
      <Filter
        filterSetup={filterSetupBetRecordData}
        filterDefaultValue={filterDefaultValue}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        onReset={() => {
          //if need some aditional reset logic in the page

          console.debug("RESET FILTER");
          // filterDefaultValue.upper_agent_account = ""
          Object.keys(dependency).forEach((key) => {
            setDependency((prevState) => {
              return {
                ...prevState,
                [key]: filterDefaultValue[key],
              };
            });
          });
        }}
        onSubmitSearch={onHandleSearch}
        setDependency={setDependency}
        dependency={dependency}
        apiValue={{
          [filterKeyBetRecordData.GAME_CODE]: {
            value_enum: gameValues,
          },
          [filterKeyBetRecordData.GAME_SUB_CODE]: {
            value_enum: allSubGames.data ?? [],
          },
        }}
        // activeTab={activeTab}
      />
      <CustomDateTabs
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        startDateKey={filterKeyBetRecordData.START_DATE}
        endDateKey={filterKeyBetRecordData.END_DATE}
      />
      <FilterTag
        filterSetup={filterSetupBetRecordData}
        filterValue={filterValue}
        filterDefaultValue={filterDefaultValue}
        setFilterValue={setFilterValue}
        refreshSearch={onHandleSearch}
        apiValue={{
          [filterKeyBetRecordData.GAME_CODE]: {
            value_enum: gameValues,
          },
          [filterKeyBetRecordData.GAME_SUB_CODE]: {
            value_enum: allSubGames.data ?? [],
          },
        }}
      />
      {getBetRecord.isLoading ? (
        ""
      ) : getBetRecord.isError ? (
        ""
      ) : (
        <CustomTable
          columns={columns}
          dataSource={tableData}
          hasMore={getBetRecord.hasNextPage}
          loadMore={async () => {
            if (getBetRecord.isFetchingNextPage === false && tableData.length > 0) {
              await getBetRecord.fetchNextPage();
            }
          }}
          showInifineScroll={true}
        />
      )}
    </div>
  );
}

export default Report;
